import React, { Fragment } from 'react';
import Icon from 'components/Icon/Icon';
import { Typography, makeStyles, Box, Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { themeStep } from 'features/step-menu/themeStep';
import styled from 'styled-components';
import { useStore } from 'features/home/store/homeSlice';
import { shallow } from 'zustand/shallow';
import { handleRouter } from 'utils/restaurantFeatures';

interface CartHeaderStepProps {
  isDisableContinue: () => boolean;
  onContinue: () => void;
}

const HeaderCartStep = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
  margin: 0 0px 4px 0px;
  padding: 10px 20px;
  background-color: ${themeStep.palette.grey[200]};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const BoxIcon = styled(Box)`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export interface StepPageType {
  menuId: string;
  tableId: string;
}

const CartHeaderStep = ({ isDisableContinue, onContinue }: CartHeaderStepProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { state } = useStore(
    (state) => ({
      state: state.homeState,
    }),
    shallow,
  );
  const onClick = () => {
    handleRouter({
      history,
      state,
      customUrl: '',
      fileName: 'CartHeaderStep',
    });
  };

  return (
    <Fragment>
      <HeaderCartStep>
        <Box flex="1">
          <IconButton onClick={onClick} className={classes.backButton}>
            <BoxIcon>
              <Icon name="leftArrow" className={classes.backIcon}></Icon>
            </BoxIcon>
          </IconButton>
        </Box>
        <Box flex="1" textAlign="center">
          <Typography className={classes.headerTitle}>{t('Cart')}</Typography>
        </Box>
        <Box flex="1" textAlign="end">
          <Button
            disabled={isDisableContinue()}
            onClick={onContinue}
            className={classes.buttonTitle}
          >
            <Typography className={classes.textButtonTitle}>{t('Continue')}</Typography>
          </Button>
        </Box>
      </HeaderCartStep>
    </Fragment>
  );
};

export default CartHeaderStep;
const useStyles = makeStyles({
  backButton: {
    color: themeStep.palette.text.primary,
    padding: 0,
    width: 40,
    height: 40,
  },
  backIcon: {
    height: 22,
    width: 22,
    color: themeStep.palette.grey[800],
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: '17px',
    lineHeight: '22px',
    letterSpacing: '-0.43px',
    textTransform: 'none',
    color: themeStep.palette.grey[800],
  },
  buttonTitle: {
    padding: 5,
    border: `1px solid ${themeStep.palette.grey[800]}`,
    '&:disabled': {
      border: `1px solid ${themeStep.palette.grey[500]}`,
      '& $textButtonTitle': {
        color: themeStep.palette.grey[500],
      },
    },
  },
  textButtonTitle: {
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '-0.15px',
    color: themeStep.palette.grey[800],
  },
});
